import { MapProperties } from '@datum-group/datum-map/lib';
import { GeoJSONMapMarkerAdapter } from './GeoJSONMapMarkerAdapter';
import type { IMarker, StyleVariant } from './MapMarker';

export class MapMarkerFacade implements IMarker<GeoJSON.Geometry> {
  private _markerController: GeoJSONMapMarkerAdapter;
  relatedLayerName: string | undefined = undefined;

  constructor(mapProperties: MapProperties) {
    this._markerController = new GeoJSONMapMarkerAdapter({
      addLayer: mapProperties.map.addLayer.bind(mapProperties.map),
      removeLayer: mapProperties.map.removeLayer.bind(mapProperties.map),
    });
  }

  create = (
    geom: GeoJSON.Geometry,
    style?: StyleVariant,
    relatedLayerName?: string,
  ) => {
    this._markerController.create(geom, style);
    this.relatedLayerName = relatedLayerName;
  };

  remove = () => {
    this._markerController.remove();
    this.relatedLayerName = undefined;
  };
}
